module.exports = __webpack_public_path__ + "static/media/v01-01.0b08d844.png";